import {default_language} from "./lang";
import PathToRegexp from "path-to-regexp";
import {ROUTE} from "./consts";

const generateLanguageURL = (url, language) => {
    const routeComponents = PathToRegexp(ROUTE).exec(url);
    if (routeComponents) {
        if (routeComponents[2]) {
            return routeComponents[1].length === 2
                ? `/${default_language === language ? '' : language + '/'}${routeComponents[2]}/`
                : `/${default_language === language ? '' : language}${routeComponents[0]}/`;
        } else if (routeComponents[1]) {
            return routeComponents[1].length === 2
                ? default_language === language ? '/' : `/${language}/`
                : `/${default_language === language ? '' : language + '/'}${routeComponents[1]}/`;
        }
    } else {
        return default_language === language ? '/' : language + '/';
    }
};

export default generateLanguageURL;